import {Locales} from "../../../localization/types";

export const getData = (locale: Locales) => {
  if (locale === 'ru-BY') {
    return {
      title: 'Тарифы',
      periods: [
        {
          label: 'Год',
          name: 'year',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 660,
              //priceFull: 900,
              currency: ' BYN',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 900,
              //priceFull: 1320,
              currency: ' BYN',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования',
              price: 1200,
              //priceFull: 2040,
              popular: true,
              currency: ' BYN',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 1800,
              //priceFull: 2600,
              currency: ' BYN',
            },
          ],
        },
        {
          label: 'Месяц',
          name: 'month',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 66,
              currency: ' BYN',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 85,
              currency: ' BYN',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования',
              price: 110,
              popular: true,
              currency: ' BYN',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 170,
              currency: ' BYN',
            },
          ],
        },
      ],
    }
  }
  if (locale === 'ru-KZ') {
    return {
      title: 'Тарифы',
      periods: [
        {
          label: 'Год',
          name: 'year',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 70800,
              //priceFull: 900,
              currency: ' ₸',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 170000,
              //priceFull: 204000,
              currency: ' ₸',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования ',
              price: 225000,
              //priceFull: 270000,
              popular: true,
              currency: ' ₸',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 285000,
              //priceFull: 342000,
              currency: ' ₸',
            },
          ],
        },
        {
          label: 'Месяц',
          name: 'month',
          items: [
            {
              name: 'Web',
              color: 'green',
              description: 'Базовые инструменты для быстрых продаж',
              price: 9000,
              //priceFull: 900,
              currency: ' ₸',
            },
            {
              name: 'Start',
              color: 'blueOcean',
              description: 'Инструменты захвата новой аудитории',
              price: 17000,
              currency: ' ₸',
            },
            {
              name: 'Standard',
              color: 'fuchsia',
              description: 'Система развития и масштабирования ',
              price: 22500,
              popular: true,
              currency: ' ₸',
            },
            {
              name: 'Pro',
              color: 'orange',
              description: 'Модули глубокой аналитики и финансов',
              price: 28500,
              currency: ' ₸',
            },
          ],
        },
      ],
    }
  }

  return {
    title: 'Тарифы',
    periods: [
      {
        label: 'Год',
        name: 'year',
        items: [
          {
            name: 'Web',
            color: 'green',
            description: 'Базовые инструменты для быстрых продаж',
            price: 19880,
            //priceFull: 19880,
          },
          {
            name: 'Start',
            color: 'blueOcean',
            description: 'Инструменты захвата новой аудитории',
            price: 34880,
            //priceFull: 34880,
          },
          {
            name: 'Standard',
            color: 'fuchsia',
            description: 'Система развития и масштабирования',
            price: 49880,
            //priceFull: 49880,
            popular: true,
          },
          {
            name: 'Pro',
            color: 'orange',
            description: 'Модули глубокой аналитики и финансов',
            price: 59880,
            //priceFull: 59880,
          },
        ],
      },
      {
        label: 'Месяц',
        name: 'month',
        items: [
          {
            name: 'Web',
            color: 'green',
            description: 'Базовые инструменты для быстрых продаж',
            price: 1990,
          },
          {
            name: 'Start',
            color: 'blueOcean',
            description: 'Инструменты захвата новой аудитории',
            price: 3490,
          },
          {
            name: 'Standard',
            color: 'fuchsia',
            description: 'Система развития и масштабирования',
            price: 4990,
            popular: true,
          },
          {
            name: 'Pro',
            color: 'orange',
            description: 'Модули глубокой аналитики и финансов',
            price: 5990,
          },
        ],
      },
    ],
  }
}
